/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CreateLeadCapturePopupCancelIcon from "../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import CloseIcon from "../../../../assets/icons/closeIcon.svg";
import "./lead-qualification-merge-confirmation-popups.scss";

const LeadQualificationMergeConfirmationPopups= (props: any) => {
   const {
        setIsShowConfirmMergePopup,
        isShowConfirmMergePopup,
        handleConfirmMerge
  } = props;
  return (
    <>
     <Dialog
        open={isShowConfirmMergePopup}
        // onClose={() => setIsShowConfirmMergePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`create-lead-capture-popup-cancel`}
      >
        <DialogTitle id="alert-dialog-title">
            <div className="header-wrapper">
              <div className="image-wrapper">
                <img src={CreateLeadCapturePopupCancelIcon} className="delete-icon"></img>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={() => setIsShowConfirmMergePopup(false)}
                />
              </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="cancel-popup-text">
              Confirm Merge
            </div>
            <div className="cancel-popup-sub-text">
              All other  duplicates will be permanently merged into primary lead.
            </div>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() =>setIsShowConfirmMergePopup(false)} className="cancel-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirmMerge} autoFocus className="action-btn">
            Confirm Merge
          </Button>
        </DialogActions>
      </Dialog>          
    </>
  );
}

export default LeadQualificationMergeConfirmationPopups;
